import { render, staticRenderFns } from "./SearchEmptyState.vue?vue&type=template&id=074c11c0&"
import script from "./SearchEmptyState.vue?vue&type=script&lang=js&"
export * from "./SearchEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports